/* Desktop-only: hovering a colour swatch on a product card swaps the card's
   main image to that variant's photo AND updates the card price to that
   variant's price (sale variants show the sale price plus a struck-through
   compare-at); both restore on mouse-out. Gated to devices with a real
   cursor — touch devices (phones, iPads) never activate this; there the
   swipeable strip (card-variant-carousel.js) does the same job.
   Variant photos are prefetched the first time the cursor enters a card, so
   nothing extra is downloaded at page load.
   Combined listings: sibling swatches carry data-sibling-url instead of an
   image; on first card hover the sibling product's .js JSON is fetched and its
   featured image + price are used. */
(function () {
  if (window.__swatchHoverInit) return;
  window.__swatchHoverInit = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function mediaFor(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card__media .media') : null;
  }

  function priceFor(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card-information .price') : null;
  }

  /* Match the store's money format: whole amounts show NO decimals (£199, not
     £199.00), the same as Liquid's money filter here. Only genuinely
     fractional prices keep their pennies. */
  function fmtMoney(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(cents / 100);
    } catch (err) {
      return '£' + (whole ? String(cents / 100) : (cents / 100).toFixed(2));
    }
  }

  function prefetchCard(card) {
    card.querySelectorAll('.card-swatches__swatch').forEach(function (s) {
      var u = s.getAttribute('data-variant-image');
      if (u) {
        var im = new Image();
        im.src = u;
        return;
      }
      var pu = s.getAttribute('data-sibling-url');
      if (!pu) return;
      fetch(pu.split('?')[0] + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          if (typeof p.price === 'number' && !s.hasAttribute('data-variant-price')) {
            s.setAttribute('data-variant-price', fmtMoney(p.price));
            if (p.compare_at_price && p.compare_at_price > p.price) {
              s.setAttribute('data-variant-compare', fmtMoney(p.compare_at_price));
            }
          }
          if (!p.featured_image) return;
          var url = p.featured_image;
          url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=533';
          s.setAttribute('data-variant-image', url);
          var im = new Image();
          im.src = url;
        })
        .catch(function () {});
    });
  }

  function showPrice(swatch) {
    var priceText = swatch.getAttribute('data-variant-price');
    if (!priceText) return;
    var priceEl = priceFor(swatch);
    if (!priceEl) return;
    if (!priceEl.hasAttribute('data-orig-html')) {
      priceEl.setAttribute('data-orig-html', priceEl.innerHTML);
      priceEl.setAttribute('data-orig-class', priceEl.className);
    }
    var compare = swatch.getAttribute('data-variant-compare');
    var saleCompare = priceEl.querySelector('.price__sale .price-item--regular');
    var saleItem = priceEl.querySelector('.price__sale .price-item--sale');
    var regItem = priceEl.querySelector('.price__regular .price-item--regular');
    if (compare && saleCompare && saleItem) {
      saleCompare.textContent = compare;
      saleItem.textContent = priceText;
      priceEl.classList.add('price--on-sale');
    } else if (regItem) {
      regItem.textContent = priceText;
      priceEl.classList.remove('price--on-sale');
    }
  }

  function restorePrice(swatch) {
    var priceEl = priceFor(swatch);
    if (!priceEl || !priceEl.hasAttribute('data-orig-html')) return;
    priceEl.innerHTML = priceEl.getAttribute('data-orig-html');
    priceEl.className = priceEl.getAttribute('data-orig-class');
    priceEl.removeAttribute('data-orig-html');
    priceEl.removeAttribute('data-orig-class');
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;

    // Prefetch this card's variant photos on first cursor entry
    var card = e.target.closest('.card-wrapper');
    if (card && !card.hasAttribute('data-swatch-prefetched')) {
      card.setAttribute('data-swatch-prefetched', '1');
      prefetchCard(card);
    }

    var swatch = e.target.closest('.card-swatches__swatch');
    if (!swatch) return;

    showPrice(swatch);

    var url = swatch.getAttribute('data-variant-image');
    if (!url) return;
    var media = mediaFor(swatch);
    var img = media && media.querySelector('img');
    if (!img) return;
    if (!img.hasAttribute('data-orig-src')) {
      img.setAttribute('data-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
    }
    media.classList.add('swatch-hovering');
    img.removeAttribute('srcset');
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var swatch = e.target.closest('.card-swatches__swatch');
    if (!swatch) return;
    // Moving directly onto another swatch? Its mouseover will take over.
    if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.card-swatches__swatch')) return;

    restorePrice(swatch);

    var media = mediaFor(swatch);
    var img = media && media.querySelector('img');
    if (!img || !img.hasAttribute('data-orig-src')) return;
    img.setAttribute('src', img.getAttribute('data-orig-src'));
    var ss = img.getAttribute('data-orig-srcset');
    if (ss) img.setAttribute('srcset', ss);
    media.classList.remove('swatch-hovering');
  });
})();
